import React from 'react';
import { translate } from 'react-i18next';
import { func, object } from 'prop-types';

import { NotFound as NotFoundComponent } from '@snapask/common-components';

import { HELP } from '@blueberry/constants/pageUrl';

import config from '@blueberry/config';
const { SNAPASK_SITE_ENDPOINT } = config;

function NotFound({ t }) {
  const replaceLink = text =>
    text.replace(HELP, `${SNAPASK_SITE_ENDPOINT}${HELP}`);

  const description = replaceLink(t('error.404.description'));

  return (
    <NotFoundComponent description={description} title={t('error.404.title')} />
  );
}

NotFound.propTypes = {
  t: func.isRequired,
  staticContext: object, // eslint-disable-line react/require-default-props
};

export default translate(['error'])(NotFound);



// WEBPACK FOOTER //
// ./app/components/NotFound/NotFound.jsx